export default "__VITE_ASSET__Bv3zyBmx__"